import { Pipe, PipeTransform } from '@angular/core';

import { tiposVenda } from '../config-pedido-tipo-venda-indicador';

@Pipe({
    name: 'pedidoTipoVendaSinonimo'
})
export class ConfigPedidoTipoVendaSinonimoPipe implements PipeTransform {
    transform(value: number): string {
        if (!value) {
            return 'Pedido';
        }

        const index = tiposVenda.findIndex(tipo => tipo.id === value);
        if (index > -1) {
            return tiposVenda[index].sinonimo;
        }

        return 'Pedido';
    }
}
